module.exports = __webpack_public_path__ + "static/media/AIbackground_sm.fa6f0383.jpg";